module.exports = __webpack_public_path__ + "static/img/sy-img3.2d4dde5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sy-img3.png
// module id = 0jiG
// module chunks = 1